class stylesheet {
  create = (styles = {}) => {
    return styles;
  };
}

const StyleSheet = new stylesheet();
export default StyleSheet;
